








































































































import { Component, Prop, Vue } from "vue-property-decorator";
import GiftCardModal from "@/views/gift-cards/partials/GiftCardModal.vue";
import { eligibleHeaders } from "@/helpers/gift-cards/gift-card-table-headers";
import { footerProps } from "@/helpers/footer-props";
import { formatDate } from "@/helpers/functions/format-date";

@Component({
  name: "EligibleGiftCards",
  components: { GiftCardModal }
})
export default class EligibleGiftCards extends Vue {
  // ===== Refs ===== //
  $refs!: {
    confirmationNumber: HTMLFormElement;
  }

  // ===== Props ===== //
  @Prop(Boolean) private readonly loading!: boolean;

  // ===== Store ===== //

  // ===== Data ===== //
  public bulkIssueModal = false;
  public confirmationNumber = null;
  public eligibleHeaders = eligibleHeaders;
  public footerProps = footerProps;

  // ===== Methods ===== //
  public formatDate = formatDate;

  public downloadCsv(): void {
    this.$store.dispatch("downloadGiftCardCsv");
  };

  public cancelBulkIssue(): void {
    this.confirmationNumber = null;
    this.bulkIssueModal = false;
  };

  public processBulkIssue(): void {
    if (!this.confirmationNumber) {
      this.$refs.confirmationNumber.validate(true);
      return;
    }

    this.$store.dispatch("bulkIssueReward", {
      reward_confirmation: this.confirmationNumber
    }).then(() => {
      this.cancelBulkIssue();
    });
  }

  // ===== Computed ===== //
  get eligibleCards() {
    return this.$store.state.giftCards.eligibleCards;
  }
};
